import { render, staticRenderFns } from "./TheHomeSecond.vue?vue&type=template&id=6b672c3d&scoped=true&"
import script from "./TheHomeSecond.vue?vue&type=script&lang=js&"
export * from "./TheHomeSecond.vue?vue&type=script&lang=js&"
import style0 from "./TheHomeSecond.vue?vue&type=style&index=0&id=6b672c3d&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b672c3d",
  null
  
)

export default component.exports